import React, { useCallback, useState } from 'react';
import SearchInput from '../../../../components/SearchInput';
import useAuth from '../../../../context/AuthContext';
import SideActionBoard from '../../../../components/SideActionBoard';
import { STATUS_OPTIONS, BANNER_TYPES, APPLICATIONS } from '../../../../api/systemBanner';

const Filters = ({ onSelectFilters, selectedFilters }) => {
  const [filters, setFilters] = useState(selectedFilters);

  const handleFilterChange = (key, value) => {
    const newFilters = { ...filters };
    if (value) {
      newFilters[key] = value;
    } else {
      delete newFilters[key];
    }
    setFilters(newFilters);
    onSelectFilters(newFilters);
  };

  return (
    <div className="p-8">
      <h2 className="text-xl font-bold mb-6">Filters</h2>

      <div className="mb-4">
        <label className="block text-sm font-semibold text-gray-700 mb-2">
          Status
        </label>
        <select
          value={filters.status || ''}
          onChange={(e) => handleFilterChange('status', e.target.value)}
          className="w-full border border-gray-300 rounded-lg p-3"
        >
          {STATUS_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <div className="mb-4">
        <label className="block text-sm font-semibold text-gray-700 mb-2">
          Banner Type
        </label>
        <select
          value={filters.banner_type || ''}
          onChange={(e) => handleFilterChange('banner_type', e.target.value)}
          className="w-full border border-gray-300 rounded-lg p-3"
        >
          <option value="">All Types</option>
          {BANNER_TYPES.map((type) => (
            <option key={type.value} value={type.value}>
              {type.label}
            </option>
          ))}
        </select>
      </div>

      <div className="mb-4">
        <label className="block text-sm font-semibold text-gray-700 mb-2">
          Application
        </label>
        <select
          value={filters.application || ''}
          onChange={(e) => handleFilterChange('application', e.target.value)}
          className="w-full border border-gray-300 rounded-lg p-3"
        >
          <option value="">All Applications</option>
          {APPLICATIONS.map((app) => (
            <option key={app.value} value={app.value}>
              {app.label}
            </option>
          ))}
        </select>
      </div>

      <button
        type="button"
        className="mt-4 p-3 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
        onClick={() => {
          setFilters({});
          onSelectFilters({});
        }}
      >
        Clear Filters
      </button>
    </div>
  );
};

const TabSelection = ({
  tabs,
  setCurrentTab,
  currentTab,
  searchQuery,
  setSearchQuery,
  filter,
  setFilter,
  setOpenSideActionBoard,
}) => {
  const { userData, isEmployee } = useAuth();
  const isAdmin = userData?.roles?.includes('admin');
  const hasAccess = isAdmin || isEmployee;
  const [toggleFilter, setToggleFilter] = useState(false);

  const onSelectFilters = useCallback(
    (selectedFilters) => setFilter(selectedFilters),
    [setFilter]
  );

  return (
    <>
      <div className="border-b-2 border-gray flex items-center justify-between mb-6">
        <div className="flex items-center gap-6">
          {hasAccess && (
            <ul className="flex items-center p-0">
              {tabs.map((val) => (
                <div
                  key={val.label}
                  className={`${
                    currentTab?.label === val?.label &&
                    searchQuery === '' &&
                    'border-b-4 border-purple'
                  }`}
                >
                  <button
                    onClick={() => setCurrentTab(val)}
                    type="button"
                    className={`px-4 py-5 ${
                      currentTab?.label === val?.label &&
                      searchQuery === '' &&
                      'font-semibold'
                    }`}
                  >
                    {val.label}
                  </button>
                </div>
              ))}
            </ul>
          )}
          {hasAccess && currentTab?.show?.search && (
            <SearchInput
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              active={searchQuery !== ''}
            />
          )}
          <p
            className="underline cursor-pointer"
            onClick={() => setToggleFilter(true)}
          >
            {`Filters${
              Object.keys(filter).length > 0
                ? ' (' + Object.keys(filter).length + ')'
                : ''
            }`}
          </p>
        </div>
        <div className="flex">
          {hasAccess && (
            <button
              type="button"
              className="flex items-center justify-content-center bg-purple-100 p-2 rounded-lg mr-2 hover:bg-purple-200"
              onClick={() =>
                setOpenSideActionBoard({
                  type: 'create',
                  id: null,
                })
              }
            >
              Create Banner
            </button>
          )}
        </div>
      </div>
      {toggleFilter && (
        <SideActionBoard setOpenSideActionBoard={() => setToggleFilter(false)}>
          <Filters onSelectFilters={onSelectFilters} selectedFilters={filter} />
        </SideActionBoard>
      )}
    </>
  );
};

export default TabSelection;

